import React from 'react';
import { Helmet } from 'react-helmet-async';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import { TXTINT_BRAND_BetStars } from './DefaultTitle.messages.json';

const DefaultTitle: React.FC = () => {
  const { formatMessage } = useRegulatoryIntl();

  return (
    <Helmet titleTemplate="">
      <title>{formatMessage(TXTINT_BRAND_BetStars)}</title>
    </Helmet>
  );
};

export default DefaultTitle;
